const FontSize = {
    LabelMarginBottom: '5px !important',
    textFieldLabel: '14px',
    textField: '13.5px',
};

export default FontSize;
